import { initDataLayer, isBrowser } from '../util';
let filterGroup = [];
let filterValues = [];
export function pushFilterSelection(group, label) {
    initDataLayer();
    if (!isBrowser)
        return;
    filterGroup.push(group);
    filterValues.push(label);
    window.dataLayer.push({
        event: 'filtersClicked',
        filterGroup: filterGroup.join('|'),
        filterValues: filterValues.join('|'),
    });
}
// The following method will push any Text filter given the group and the label
// If such text filter already exists, upon updating the text it will replace it with
// the new label value, and push this to wider group of filter group and values.
export function pushTextFilterSelection(group, label) {
    initDataLayer();
    if (!isBrowser)
        return;
    const indexToReplace = filterGroup.indexOf(group);
    if (indexToReplace !== -1) {
        filterGroup[indexToReplace] = group;
        filterValues[indexToReplace] = label;
    }
    else {
        filterGroup.push(group);
        filterValues.push(label);
    }
    window.dataLayer.push({
        event: 'filtersClicked',
        filterGroup: filterGroup.join('|'),
        filterValues: filterValues.join('|'),
    });
}
export function clearFilterSelection() {
    initDataLayer();
    if (!isBrowser)
        return;
    filterGroup = [];
    filterValues = [];
    window.dataLayer.push({
        event: 'filtersCleared',
        filterGroup: filterGroup.join('|'),
        filterValues: filterValues.join('|'),
    });
}
export function pushFilterDeSelection(group, label) {
    initDataLayer();
    if (!isBrowser)
        return;
    const indexToRemove = filterValues.indexOf(label);
    filterGroup.splice(indexToRemove, 1);
    filterValues.splice(indexToRemove, 1);
    window.dataLayer.push({
        event: 'filtersUnclicked',
        filterGroup: filterGroup.join('|'),
        filterValues: filterValues.join('|'),
    });
}
